import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { BaseApiService } from './base-api.service';
import { ClientDocument } from '../models/client-document';
import { Observable } from 'rxjs';
import { OTHER_OPTION } from '../shared/constants';


export interface IClientDocumentUploadResult {
  document: ClientDocument;
  files: File[];
}

export interface UploadData {
  files: File[];
  docFromClientId?: string;
  description?: string;
  matterId?: string;
  fileId?: number;
  type?: string;
}


@Injectable({
  providedIn: 'root'
})
export class ClientDocumentService extends BaseApiService<ClientDocument> {

  constructor(httpClient: HttpClient) {
    super(httpClient, `${environment.apiUrl}/DocFromClients`);
  }

  get allowedFileTypes() {
    return ['.doc', '.dot', '.docx', '.dotx', '.png', '.jpg', '.jpeg', '.xlsx', '.xls', '.pdf', '.txt', '.rtf', '.ppt', '.pptx'];
  }

  maxFileNameLength = 200;


  IsInvalidFilenameChar(char: string): boolean {
    // Force single character input
    char = char.charAt(0);
    const invalidCharMask = 0xD4008404FFFFFFFFn;
    const maskUpperValue = 64;
    const charCode = char.charCodeAt(0);

    if(charCode < maskUpperValue) {
      const charBit = 1n << BigInt(charCode);
      return (invalidCharMask & charBit) != 0n;
    }

    return char == '\\' || char == '|';

  }

  /**
   * Check if the given filename matches basic criteria for a valid filename:
   * - Does not exceed maximum length
   * - Does not contain invalid windows filename characters
   * Should match API-side validation
   * @param filename 
   */
  isValidFileName(filename: string): boolean {

    if(filename.length > this.maxFileNameLength) {
      return false;
    }

    for (let i = 0; i < filename.length; i++) {
      if (this.IsInvalidFilenameChar(filename.charAt(i))) {
        return false;
      }
    }
    return true;
  }






  getAll() {
    return super.getList();
  }

  uploadFiles(uploadData: UploadData, abortSignal?: AbortSignal) : Observable<HttpEvent<any>> {

    const formData = new FormData();

    // Add files
    uploadData.files.forEach(file => {
      formData.append('files', file);
    });

    if (uploadData.docFromClientId === OTHER_OPTION) {
      formData.append('docFromClientId', '');
    }
    else {
      formData.append('docFromClientId', uploadData.docFromClientId ?? '');
    }

    formData.append('description', uploadData.description ?? '');
    formData.append('matterId', uploadData.matterId ?? '');
    formData.append('type', uploadData.type ?? '');
    if (uploadData.fileId != null && uploadData.fileId !== undefined && uploadData.fileId !== 0) {
      formData.append('fileId', uploadData.fileId.toString());
    }
    else {
      formData.append('fileId', '');
    }

    const requestOptions: any = {
      reportProgress: true,
      observe: 'events'
    };

    // Add abort signal if provided
    if (abortSignal) {
      requestOptions.signal = abortSignal;
    }

    return this.httpClient.post<HttpEvent<any>>(`${this.baseApiUrl}/UploadFiles`, formData, requestOptions);
  

  }

  deleteDocument(documentId: string) {
    return super.delete(documentId);
  }


}

